// extracted by mini-css-extract-plugin
export default {"tabs":"FileUploadTabs_tabs__29dp-","tab":"FileUploadTabs_tab__Gyxfb","activeTab":"FileUploadTabs_activeTab__mg63y","locked":"FileUploadTabs_locked__8h7fy"};